import { writable } from "svelte/store";

const stored_mobile_menu_toggle = localStorage.getItem("mobile_menu_toggle");
export const mobile_menu_toggle = writable(stored_mobile_menu_toggle);

mobile_menu_toggle.subscribe(value => {
    console.log("mobile menu toggle", value)
    localStorage.setItem("mobile_menu_toggle", value ? value : "0");
});